import React from 'react'
import classNames from 'classnames'
import ScrollContainer from 'react-indiana-drag-scroll'
import {ComponentEnum} from '../../componentsRegistry/Registry'
import {Description} from '../../componentsRegistry/Description'
import {SchemaDiagramAndDescription} from '../../componentsRegistry/SchemaDiagramAndDescription'
import {SchemaDiagram} from '../../componentsRegistry/SchemaDiagram'
import {SchemaDescription} from '../../componentsRegistry/SchemaDescription'
import {Editor} from '../../componentsRegistry/Editor'
import {Solution} from '../../componentsRegistry/Solution'
import {MasterSolution} from '../../componentsRegistry/MasterSolution'
import {MySolution} from '../../componentsRegistry/MySolution'
import {MasterResult} from '../../componentsRegistry/MasterResult'
import {MyResult} from '../../componentsRegistry/MyResult'
import {Theory} from '../../componentsRegistry/Theory'
import {TaskListBlock} from '../../componentsRegistry/TaskListBlock'
import {DdlResult} from '../../componentsRegistry/DdlResult'
import {QueryResults} from '../../componentsRegistry/QueryResults'
import {EditorSetting} from '../../componentsRegistry/EditorSetting'

interface IWindowContentProps {
  id: string
  componentId: ComponentEnum
  innerActiveComponentId?: ComponentEnum
  onClickInnerToolbarTab?: (currentId: ComponentEnum) => void
  splitTabs?: (
    leftComponentId: ComponentEnum,
    rightComponentId: ComponentEnum,
    fullscreenActiveLeftComponentId: ComponentEnum,
    fullscreenActiveRightComponentId: ComponentEnum,
  ) => void
  onSetWindowStyle?: (newStyle: number) => void
  isScrollContainer?: boolean
  isShowStart?: boolean
  className?: string
  classNameAlternative?: string
}

const WindowContent: React.FC<IWindowContentProps> = ({
  id,
  componentId,
  innerActiveComponentId,
  onClickInnerToolbarTab,
  splitTabs,
  onSetWindowStyle,
  isScrollContainer,
  isShowStart,
  className,
  classNameAlternative,
}): React.ReactElement => {
  switch (componentId) {
    case ComponentEnum.description: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <Description id={id} />
        </div>
      )
    }
    case ComponentEnum.schema: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <SchemaDiagramAndDescription
            id={id}
            innerActiveComponentId={innerActiveComponentId}
            onClickInnerToolbarTab={onClickInnerToolbarTab}
            splitTabs={
              splitTabs
                ? (leftComponentId, rightComponentId) => {
                    splitTabs(leftComponentId, rightComponentId, undefined, undefined)
                  }
                : undefined
            }
          />
        </div>
      )
    }
    case ComponentEnum.schemaDiagram: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          {isScrollContainer ? (
            <ScrollContainer horizontal vertical hideScrollbars={false} className={'content h-100 custom-scroll'}>
              <SchemaDiagram id={id} />
            </ScrollContainer>
          ) : (
            <SchemaDiagram id={id} />
          )}
        </div>
      )
    }
    case ComponentEnum.schemaDescription: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <SchemaDescription id={id} />
        </div>
      )
    }
    case ComponentEnum.editor: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <Editor id={id} />
        </div>
      )
    }
    case ComponentEnum.solution: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <Solution
            id={id}
            innerActiveComponentId={innerActiveComponentId}
            onClickInnerToolbarTab={onClickInnerToolbarTab}
            splitTabs={
              splitTabs
                ? (leftComponentId, rightComponentId) => {
                    splitTabs(leftComponentId, rightComponentId, undefined, undefined)
                  }
                : undefined
            }
          />
        </div>
      )
    }
    case ComponentEnum.masterSolution: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <MasterSolution id={id} />
        </div>
      )
    }
    case ComponentEnum.mySolution: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <MySolution id={id} />
        </div>
      )
    }
    case ComponentEnum.masterResult: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <MasterResult id={id} />
        </div>
      )
    }
    case ComponentEnum.myResult: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <MyResult id={id} />
        </div>
      )
    }
    case ComponentEnum.theory: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <Theory id={id} isShowStart={isShowStart} />
        </div>
      )
    }
    case ComponentEnum.taskList: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <TaskListBlock id={id} />
        </div>
      )
    }
    //TODO:: Пока не используются это на будующие
    case ComponentEnum.ddlResult: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <DdlResult id={id} />
        </div>
      )
    }
    //TODO:: Пока не используются это на будующие
    case ComponentEnum.queryResults: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <QueryResults id={id} />
        </div>
      )
    }
    case ComponentEnum.editorSetting: {
      let css
      if (classNameAlternative) {
        css = classNameAlternative
      } else {
        css = classNames('task-tab-content custom-scroll', className)
      }
      return (
        <div id={id} data-id={id} className={css}>
          <EditorSetting id={id} onSetWindowStyle={onSetWindowStyle} />
        </div>
      )
    }
  }
  return <></>
}

export {WindowContent}
